import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
  },

  {
    path: 'about',
    loadComponent: () =>
      import('./pages/about/about.component').then((m) => m.AboutComponent),
  },

  {
    path: 'services',
    loadComponent: () =>
      import('./pages/service/service.component').then(
        (m) => m.ServiceComponent
      ),
  },

  {
    path: 'services/mep-works',
    loadComponent: () =>
      import('./pages/mep-works/mep-works.component').then(
        (m) => m.MepWorksComponent
      ),
  },

  {
    path: 'services/:slug',
    loadComponent: () =>
      import('./pages/service-detail/service-detail.component').then(
        (m) => m.ServiceDetailComponent
      ),
  },

  {
    path: 'clients',
    loadComponent: () =>
      import('./pages/clients/clients.component').then(
        (m) => m.ClientsComponent
      ),
  },

  {
    path: 'projects',
    loadComponent: () =>
      import('./pages/projects/projects.component').then(
        (m) => m.ProjectsComponent
      ),
  },

  {
    path: 'projects/:slug',
    loadComponent: () =>
      import('./pages/projectdetails/projectdetails.component').then(
        (m) => m.ProjectdetailsComponent
      ),
  },

  {
    path: 'policies/:slug',
    loadComponent: () =>
      import('./pages/policy/policy.component').then((m) => m.PolicyComponent),
  },

  {
    path: 'hse',
    loadComponent: () =>
      import('./pages/hse/hse.component').then((m) => m.HseComponent),
  },

  {
    path: 'quality',
    loadComponent: () =>
      import('./pages/quality/quality.component').then(
        (m) => m.QualityComponent
      ),
  },

  // old combined page
  { path: 'hse-quality', redirectTo: 'hse', pathMatch: 'full' },

  {
    path: 'careers',
    loadComponent: () =>
      import('./pages/careers/careers.component').then(
        (m) => m.CareersComponent
      ),
  },

  {
    path: 'blogs',
    loadComponent: () =>
      import('./pages/blogs/blogs.component').then((m) => m.BlogsComponent),
  },

  {
    path: 'blog/:slug',
    loadComponent: () =>
      import('./pages/blogdetails/blogdetails.component').then(
        (m) => m.BlogdetailsComponent
      ),
  },

  {
    path: 'contact',
    loadComponent: () =>
      import('./pages/contact/contact.component').then(
        (m) => m.ContactComponent
      ),
  },
];
